import { LIMPAR_VEICULOS_DISPONIVEIS } from '../types'

export default function limparVeiculosDisponiveis () {
  return {
    type: LIMPAR_VEICULOS_DISPONIVEIS
  }
}

